import React from 'react';
import { Quote, Loader2 } from 'lucide-react';
import { Reveal } from './Reveal';

export const TestimonialsSection = ({ temoignages, loading }) => (
  <section className="section-spacing bg-light-blue/20">
    <div className="max-w-7xl mx-auto px-4 md:px-8">
      <Reveal className="max-w-2xl mb-14">
        <p className="text-xs uppercase tracking-[0.25em] font-semibold text-warm-accent mb-4">Ils nous font confiance</p>
        <h2 className="font-heading text-3xl md:text-5xl font-light tracking-tight text-primary-blue">
          La satisfaction de nos clients, notre plus belle réussite
        </h2>
      </Reveal>

      {loading ? (
        <div className="flex items-center justify-center py-12">
          <Loader2 className="w-6 h-6 animate-spin text-primary-blue mr-3" />
          <span className="text-text-gray">Chargement des témoignages…</span>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {temoignages.map((temoignage, i) => (
            <Reveal key={temoignage.id || temoignage.nom} delay={i * 100}>
              <div className="h-full bg-white rounded-3xl p-8 border border-border-soft shadow-sm hover:shadow-lg transition-shadow duration-300">
                <Quote className="w-9 h-9 text-warm-accent mb-5" />
                <p className="text-text-dark leading-relaxed mb-6 italic">“{temoignage.avis}”</p>
                <div className="pt-5 border-t border-border-soft">
                  <p className="font-heading font-medium text-primary-blue">{temoignage.nom}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      )}
    </div>
  </section>
);
